

import styled from "styled-components"
import { NumericFormat } from 'react-number-format';
import { FaPlus } from "react-icons/fa6";
import { showModal } from "../../../../features/modal/modalSlice";
import { useDispatch } from "react-redux";
import { updateTotalFerryPrice } from "../../../../features/nakliyeHesaplama/nakliyeHesaplamaSlice";

const Container = styled.div`
    width: ${({inputWidth}) => inputWidth};
    height: auto;
    filter: none !important;
    background-color: transparent;
    position: relative;

    .input-wrapper{
        display: flex;
        align-items: center;
        
        input{
            width: 100%;
            height: 100%;
            padding: 10px 20px;
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            border-radius: ${({radius}) => `${radius} 0 0 ${radius}`};
            color: var(--color-dark);
            background-color: ${({theme}) => theme.mainBgColor};
            
            &:-webkit-autofill,
            &:-webkit-autofill:hover, 
            &:-webkit-autofill:focus, 
            &:-webkit-autofill:active{
                -webkit-box-shadow: 0 0 0 30px white inset !important;
            }
        }
        
        input:focus ~ label{
            color: ${({theme}) => theme.mainTextColor};
            transform: translateY(-22px);
        }

        .plus-btn{
            background-color: var(--color-main);
            width: 45px;
            height: 38px;
            border-radius: ${({radius}) => `0 ${radius} ${radius} 0`};
            display: flex;
            justify-content: center;
            align-items: center;

            .plus-icon{
                color: #fff;
                font-size: 1.2rem;
            }
        }
    }
        
        label{
            position: absolute;
            transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
    }
`

const NakliyeFeribotInput = ({data, isRequired, name, labelText, inputWidth}) => {

    const dispatch = useDispatch()

  return (
    <Container value={data} radius={"5px"} inputWidth={inputWidth}>
        <div className="input-wrapper">
            <NumericFormat type="text" id={"text"} thousandSeparator={'.'} decimalSeparator={','} suffix={data ? " TL" : ""}  onChange={(e) => dispatch(updateTotalFerryPrice(parseInt(e.target.value || 0)))} value={data || ""} name={name}/> 
            <button className="plus-btn"onClick={() => dispatch(showModal("addFerryPrices"))}><FaPlus className="plus-icon"/></button>
            <label htmlFor={"text"}>{labelText}{isRequired && "*"} </label>
        </div>
    </Container>
  )
}

export default NakliyeFeribotInput